export default __webpack_public_path__ + "static/media/Darryl Archideld.4ae99e44.jpg";